import React, { useState } from 'react';
import { Sparkles, X, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import AppLink from './AppLink';

const KEY = 'ndp_drive_bar_dismissed';

export const DriveBar = () => {
  const { t } = useLanguage();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === '1');
  if (hidden) return null;
  const close = () => { localStorage.setItem(KEY, '1'); setHidden(true); };
  return (
    <div className="relative bg-[#0B0B0F] text-white" data-testid="drive-bar">
      <AppLink to="/join" className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-10 py-2 text-xs font-semibold sm:text-sm" data-testid="drive-bar-link">
        <Sparkles className="h-4 w-4 shrink-0 text-[#00E676]" />
        <span className="truncate">{t({ en: 'Membership Drive 2026 is live — join in 2 minutes & get your digital ID', bn: 'সদস্যপদ অভিযান ২০২৬ চলছে — ২ মিনিটে যোগ দিন ও ডিজিটাল আইডি নিন' })}</span>
        <span className="hidden shrink-0 items-center gap-1 rounded-full bg-[#00E676] px-2.5 py-0.5 font-bold text-black sm:inline-flex">{t({ en: 'Join now', bn: 'এখনই যোগ দিন' })} <ArrowRight className="h-3 w-3" /></span>
      </AppLink>
      <button onClick={close} aria-label="Dismiss" className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-1 text-white/60 transition-colors hover:bg-white/10 hover:text-white" data-testid="drive-bar-close">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
